import { render, staticRenderFns } from "./CreatePotInternal.vue?vue&type=template&id=081c3533&"
import script from "./CreatePotInternal.vue?vue&type=script&lang=js&"
export * from "./CreatePotInternal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports